// Declare the AXML namespace.
'use strict';
import gtn from './GTNexus.Common';

gtn.ui.axml = {};

gtn.ui.axml.tagDefs = {
    c:      { tag: "span", nested: false, class: "apx-inline-code" },
    d:      { tag: "span", nested: false, class: "data-type" },
    e:      { tag: "span", nested: false, class: "entity-name" },
    f:      { tag: "span", nested: false, class: "flag" },
    remark: { tag: "div", nested: true, class: "remark" },
    title:  { tag: "div", nested: true,
              // The class name of the title also depends on the parent XML tag name.
              class: function ($node) { return $node.parent().prop("tagName") + "-title"; } },
    url:    { tag: "div", nested: true, class: "url" },
    curl:   { tag: "div", nested: true, class: "curl" },
    next:   { tag: "a", nested: true, class: "next-topic" },
    todo:   { tag: "span", nested: true,
              class: function ($node) { return (location.hostname == "localhost" ? "todo" : "todo-hidden"); } },
    fineprint:   { tag: "div", nested: true, class: "fineprint" }
};

gtn.ui.axml.sourceUrl = "";
gtn.ui.axml.sourceXmlText = "";
gtn.ui.axml.liveEditMode = false;
gtn.ui.axml.liveEditDetectionInterval = 1000;
gtn.ui.axml.liveEditModeHandle = null;

gtn.ui.pageReactComponentFns = [];

window.onhashchange = function () {
    if (location.hash == gtn.currentHash) {
        // This hash change was triggered by code.
        // Do nothing, as all necessary UI changes have been made.

    } else {
        // This hash change was triggered by user entry in the URL.
        // Need to make a best effort to honor the entry, though the entry might be incorrect.
        var hashObj = gtn.getHash();
        if (hashObj.version) {
            // Select the corresponding version tab.
            gtn.ui.axml.selectVersionByHash(hashObj.version);
        }

        if (hashObj.section) {
            // Select the corresponding article section.
            gtn.ui.axml.selectSectionByHash(hashObj.section);
        }
    }
};

/*
    NOT CURRENTLY IN USE
 */
gtn.ui.axml.liveEditMode = function( xmlDoc ){
    if (location.hostname == "localhost") {
        var $root = $(xmlDoc).find("axml");
        var liveEdit = $root.attr("liveEdit");
   //     liveEdit = "no";
        // Enable Live Edit mode by default, unless explicitly disabled.
        if (liveEdit != "no" && liveEdit != "false") {
            // Live Edit mode is enabled by default.
            // Set the detection interval if specified. If not specified, use default setting.
            var interval = $root.attr("interval");
            if (interval) {
                var intervalMilliseconds = parseInt(interval, 10);
                if (intervalMilliseconds < 1000) {
                    alert("Error: Live Edit interval needs to be >= 1000 milliseconds.");
                } else {
                    gtn.ui.axml.liveEditDetectionInterval = intervalMilliseconds;
                }
            }

            // Set the Live Edit detection to run again at specified intervals.
            // Clear the previous interval handle first, if any, to avoid duplicate handling.
            if (gtn.ui.axml.liveEditModeHandle) {
                clearInterval(gtn.ui.axml.liveEditModeHandle);
            }
            gtn.ui.axml.liveEditModeHandle =
                setInterval(gtn.ui.axml.getXmlAndRenderIfChanged, gtn.ui.axml.liveEditDetectionInterval);

            // Add a warning flag when Live Edit mode is enabled.
            if (gtn.ui.axml.liveEditModeHandle && $(".article-panel > .live-edit-flag").length == 0) {
                $(".article-panel").append("<div class='live-edit-flag'>Live Edit mode is on</div>");
                $(".article-panel > .live-edit-flag").click(gtn.ui.axml.toggleLiveEditor);
            }

            // Refresh the live editor code if there are new changes from outside the live editor.
            // Disable this detection when the live editor is saving, as during that process,
            // liveEditorLastGenerationXmlText and sourceXmlText can get out of sync for a brief moment,
            // but the live editor doesn't need to be refreshed in that case.
            if (gtn.ui.axml.liveEditor
                && gtn.ui.axml.liveEditorIsOpen
                && !gtn.ui.axml.liveEditorIsSaving  // When live editor is NOT saving.
                && gtn.ui.axml.liveEditorLastGenerationXmlText != gtn.ui.axml.sourceXmlText) {
                // Source code changes have originated from the file system, not the live editor.
                // Update the live editor with the new code. Maintain cursor position. Set a new generation.
                var cursorPos = gtn.ui.axml.liveEditor.doc.getCursor();
                gtn.ui.axml.liveEditor.doc.setValue(gtn.ui.axml.sourceXmlText);
                gtn.ui.axml.liveEditor.doc.setCursor(cursorPos);
                gtn.ui.axml.liveEditorLastGeneration = gtn.ui.axml.liveEditor.doc.changeGeneration();
                gtn.ui.axml.liveEditorLastGenerationXmlText = gtn.ui.axml.liveEditor.doc.getValue();
                gtn.ui.axml.syncLiveEditorCleanStateWithUI(null, null, "background-refresh");
            }

        } else {
            // Live Edit mode is disabled explicitly.
            // If it was previously running for this page, clear the handle.
            if (gtn.ui.axml.liveEditModeHandle) {
                clearInterval(gtn.ui.axml.liveEditModeHandle);
            }

            // Remove the warning flag.
            $(".article-panel > .live-edit-flag").remove();
        }
    }
}
gtn.ui.axml.liveEditor = null;
gtn.ui.axml.liveEditorLastGenerationXmlText = "";
gtn.ui.axml.liveEditorLastGeneration = null;
gtn.ui.axml.liveEditorSaveHandle = null;
gtn.ui.axml.liveEditorSaveInterval = 1000;
gtn.ui.axml.liveEditorIsOpen = false;
gtn.ui.axml.liveEditorIsSaving = false;
gtn.ui.axml.liveEditorReloadPrompt =
    "The source XML file has been changed outside of Live Editor. " +
    "Would you like to load the new changes into the Live Editor window?";
gtn.ui.axml.textDictionary = {
    "emdash": "—",
    "nbsp": "&amp;nbsp;",
    "url": "<url></url>",
    "curl": "<curl></curl>",
    "code": "<code type=\"\" line-numbers=\"\"><![CDATA[\n]]></code>",
    "code-src": "<code type=\"\" src=\"\" line-numbers=\"\" />",
    "next": "<next></next>",
    "todo": "<todo></todo>",
    "files": "<files></files>",
    "title": "<title></title>",
    "remark": "<remark>\n<title></title>\n<p></p>\n</remark>",
    "section": "<section>\n<title></title>\n<p></p>\n</section>",
    "include": "<include src=\"\" ref=\"\" selector=\"\">\n<replace text=\"\" with=\"\" />\n<remove selector=\"\" />\n<insert position=\"\" selector=\"\"></insert>\n</include>",
    "schema": "<schema ref=\"\" />",
    "fineprint": "<fineprint></fineprint>",
    "screenshot": "<screenshot src=\"\" caption=\"\" border=\"\" />",
    "ul": "<ul>\n<li></li>\n</ul>",
    "ol": "<ol>\n<li></li>\n</ol>",
    "table": "<table data-format=\"name-description\">\n<tr>\n<th></th>\n<th></th>\n</tr>\n<tr>\n<td></td>\n<td></td>\n</tr>\n</table>"
};
gtn.ui.axml.noFocusCommands = ["find", "findNext", "replace"];

gtn.ui.axml.formAxmlUrl = function( node ){
    if (node.length == 1) {
        var value = gtn.ui.hyphenEncode(node.find("> div > .k-in").text())
        return "/" + value;
    } else{
        return '/null';
    }
};

gtn.ui.axml.toggleLiveEditor = function () {
    // If the Live Editor is already open, then close it. Otherwise, open the Live Editor.
    if (gtn.ui.axml.liveEditorIsOpen) {
        // Save the changes if not saved yet.
        gtn.ui.axml.saveXmlIfChanged();
        // Hide the editor from UI.
        $(".m-body-content").removeClass("live-edit-mode");
        gtn.ui.axml.liveEditorIsOpen = false;
        // Clean up the live-save handle.
        if (gtn.ui.axml.liveEditorSaveHandle) {
            clearInterval(gtn.ui.axml.liveEditorSaveHandle);
        }

    } else {
        // Display the editor in the UI.
        $(".m-body-content").addClass("live-edit-mode");

        // If the editor panel already exists, refresh it with new code from the file system if necessary.
        // If the editor panel doesn't exist yet, create a new instance and configure it.
        if ($(".editor-panel").length > 0) {
            // Refresh the live editor code if there are new changes from the file system.
            if (gtn.ui.axml.liveEditor.doc.getValue() != gtn.ui.axml.sourceXmlText) {
                // Update the live editor with the new code. Maintain cursor position. Set a new generation.
                var cursorPos = gtn.ui.axml.liveEditor.doc.getCursor();
                gtn.ui.axml.liveEditor.doc.setValue(gtn.ui.axml.sourceXmlText);
                gtn.ui.axml.liveEditor.doc.setCursor(cursorPos);
                gtn.ui.axml.liveEditorLastGeneration = gtn.ui.axml.liveEditor.doc.changeGeneration();
                gtn.ui.axml.liveEditorLastGenerationXmlText = gtn.ui.axml.liveEditor.doc.getValue();
                gtn.ui.axml.syncLiveEditorCleanStateWithUI(null, null, "editor-open");
            }

        } else {
            $(".tree-panel").before("<div class='editor-prompt'><div class='editor-menu'></div></div>" +
                "<div class='editor-panel'></div>");
            gtn.ui.axml.configureLiveEditorMenu();

            CodeMirror.commands.save = function (cm) { gtn.ui.axml.saveXmlIfChanged(); };
            CodeMirror.commands.toLowerCase = function (cm) {
                cm.doc.replaceSelection(cm.doc.getSelection().toLowerCase());
            };
            CodeMirror.commands.toUpperCase = function (cm) {
                cm.doc.replaceSelection(cm.doc.getSelection().toUpperCase());
            };
            CodeMirror.commands.toInitialCap = function (cm) {
                var originalText = cm.doc.getSelection().toLowerCase();
                var convertedText = originalText.replace(/\b[a-z]/g, function (m) { return m.toUpperCase() });
                cm.doc.replaceSelection(convertedText);
            };

            gtn.ui.axml.liveEditor = CodeMirror($(".editor-panel")[0], {
                value: gtn.ui.axml.sourceXmlText,
                mode: "application/xml",
                extraKeys: {
                    "Ctrl-J": "toMatchingTag",
                    "Cmd-J": "toMatchingTag",
                    "Tab": function (cm) {
                        if (cm.doc.somethingSelected()) {
                            cm.execCommand("indentMore");
                        } else {
                            cm.execCommand("insertSoftTab");
                        }
                    },
                    "Shift-Tab": function (cm) {
                        cm.execCommand("indentLess");
                    },
                    "Alt-Tab": function (cm) {
                        cm.execCommand("indentAuto");
                    }
                },
                matchTags: { bothTags: true },
                autoCloseTags: true,
                lineWrapping: true,
                lineNumbers: true,
                indentUnit: 4
            });

            gtn.ui.axml.liveEditor.on("change", function (cm, changeObj) {
                gtn.ui.axml.syncLiveEditorCleanStateWithUI(cm, changeObj, "on-change");
            });

            // When certain text is selected in the preview area, highlight it in the editor too.
            $(".article-content").mouseup(function (e) {
                if (gtn.ui.axml.liveEditorIsOpen) {
                    var selectionText = gtn.ui.axml.getSelectionText();
                    if (selectionText) { gtn.ui.axml.highlightTextInLiveEditor(selectionText, e); }
                }
            })
        }

        gtn.ui.axml.liveEditorIsOpen = true;

        // Create the live-save handle.
        if (gtn.ui.axml.liveEditorSaveHandle) {
            clearInterval(gtn.ui.axml.liveEditorSaveHandle);
        }
        //
        gtn.ui.axml.liveEditorSaveHandle =
            setInterval(gtn.ui.axml.saveXmlIfChanged, gtn.ui.axml.liveEditorSaveInterval);
    }
};

gtn.ui.axml.configureLiveEditorMenu = function () {
    $(".editor-menu").kendoMenu({
        animation: false,
        dataSource: [
            {
                text: "Edit",
                items: [
                    { text: "Undo (Cmd-Z)", cssClass: "cm-command cm-name-undo" },
                    { text: "Redo (Cmd-Y)", cssClass: "cm-command cm-name-redo" },
                    { text: "<div class='k-separator'></div>", encoded: false, enabled: false },
                    { text: "Find (Cmd-F)", cssClass: "cm-command cm-name-find" },
                    { text: "Find Next (Cmd-G)", cssClass: "cm-command cm-name-findNext" },
                    { text: "Replace (Cmd-Alt-F)", cssClass: "cm-command cm-name-replace" }
                ]
            },
            {
                text: "Format",
                items: [
                    { text: "Indent (Tab)", cssClass: "cm-command cm-name-indentMore" },
                    { text: "Un-Indent (Shift-Tab)", cssClass: "cm-command cm-name-indentLess" },
                    { text: "Auto Indent (Alt-Tab)", cssClass: "cm-command cm-name-indentAuto" },
                    { text: "<div class='k-separator'></div>", encoded: false, enabled: false },
                    { text: "To all lower case", cssClass: "cm-command cm-name-toLowerCase" },
                    { text: "To ALL UPPER CASE", cssClass: "cm-command cm-name-toUpperCase" },
                    { text: "To Initial Capitalized", cssClass: "cm-command cm-name-toInitialCap" }
                ]
            },
            {
                text: "Insert...",
                items: [
                    { text: "— em dash", cssClass: "cm-insert cm-code-emdash" },
                    { text: "&nbsp;", cssClass: "cm-insert cm-code-nbsp" },
                    { text: "<div class='k-separator'></div>", encoded: false, enabled: false },
                    { text: "＜url＞ Web Address", cssClass: "cm-insert cm-code-url" },
                    { text: "＜curl＞ cURL Command", cssClass: "cm-insert cm-code-curl" },
                    { text: "＜code＞ Embedded Code", cssClass: "cm-insert cm-code-code" },
                    { text: "＜code＞ External Code File", cssClass: "cm-insert cm-code-code-src" },
                    { text: "＜next＞ Link to Next Article", cssClass: "cm-insert cm-code-next" },
                    { text: "＜todo＞ To-Do Task", cssClass: "cm-insert cm-code-todo" },
                    { text: "＜files＞ File Structure Widget", cssClass: "cm-insert cm-code-files" },
                    { text: "＜title＞ Article/Section/Remark Title", cssClass: "cm-insert cm-code-title" },
                    { text: "＜method＞ Java Method Declaration", cssClass: "cm-insert cm-code-method" },
                    { text: "＜remark＞ Important Comment Block", cssClass: "cm-insert cm-code-remark" },
                    { text: "＜section＞ Section in Article", cssClass: "cm-insert cm-code-section" },
                    { text: "＜include＞ Content Inclusion", cssClass: "cm-insert cm-code-include" },
                    { text: "＜schema＞ Object Schema Widget", cssClass: "cm-insert cm-code-schema" },
                    { text: "＜fineprint＞ Fine-Print Text Block", cssClass: "cm-insert cm-code-fineprint" },
                    { text: "＜screenshot＞ Image With Caption & Border", cssClass: "cm-insert cm-code-screenshot" },
                    { text: "<div class='k-separator'></div>", encoded: false, enabled: false },
                    { text: "＜ul＞", cssClass: "cm-insert cm-code-ul" },
                    { text: "＜ol＞", cssClass: "cm-insert cm-code-ol" },
                    { text: "＜table＞", cssClass: "cm-insert cm-code-table" }
                ]
            },
            {
                text: "Surround Text With...",
                items: [
                    { text: "＜a＞ Hyperlink", cssClass: "cm-surround-with cm-code-a" },
                    { text: "＜b＞ Bold", cssClass: "cm-surround-with cm-code-b" },
                    { text: "c Inline Code or Value", cssClass: "cm-surround-with cm-code-c" },
                    { text: "＜d＞ Data Type", cssClass: "cm-surround-with cm-code-d" },
                    { text: "＜e＞ Entity or Field Name", cssClass: "cm-surround-with cm-code-e" },
                    { text: "＜f＞ Flag (in superscript)", cssClass: "cm-surround-with cm-code-f" },
                    { text: "＜i＞ Italic", cssClass: "cm-surround-with cm-code-i" },
                    { text: "＜t＞ XML or HTML Tag", cssClass: "cm-surround-with cm-code-t" },
                    { text: "＜v＞ Variable", cssClass: "cm-surround-with cm-code-v" },
                    { text: "<div class='k-separator'></div>", encoded: false, enabled: false },
                    { text: "＜url＞ Web Address", cssClass: "cm-surround-with cm-code-url" },
                    { text: "＜curl＞ cURL Command", cssClass: "cm-surround-with cm-code-curl" },
                    { text: "＜method＞ Java Method Declaration", cssClass: "cm-surround-with cm-code-method" }
                ]
            },
            {
                text: "Help",
                items: [
                    { text: "Auto Save: ON", enabled: false },
                    { text: "Auto Find: ON", enabled: false },
                    { text: "<div class='k-separator'></div>", encoded: false, enabled: false },
                    { text: "Help on Using Live Editor", url: "javascript: window.open(\"/help/live-editor\")" },
                    { text: "Help on AXML Syntax", url: "javascript: window.open(\"/help/article-axml-syntax\")" }
                ]
            }
        ]
    });

    // Handle the CodeMirror commands-related menu items.
    $(".editor-menu li.cm-command").click(function () {
        var classList = $(this).attr("class").split(/\s+/);
        $.each(classList, function(index, item){
            if (item.substring(0, 8) == "cm-name-") {
                var commandName = item.substring(8);
                gtn.ui.axml.liveEditor.execCommand(commandName);
                // If the command is not any of the no-focus commands, then focus on the document.
                if (gtn.ui.axml.noFocusCommands.indexOf(commandName) == -1) { gtn.ui.axml.liveEditor.focus(); }
            }
        });
    });

    // Handle the "Surround Text With..." menu items.
    $(".editor-menu li.cm-surround-with").click(function () {
        var classList = $(this).attr("class").split(/\s+/);
        $.each(classList, function(index, item){
            if (item.substring(0, 8) == "cm-code-") {
                var tagName = item.substring(8);
                gtn.ui.axml.surroundCodeWithTag(tagName);
                gtn.ui.axml.liveEditor.focus();
            }
        });
    });

    // Handle the "Insert..." menu items.
    $(".editor-menu li.cm-insert").click(function () {
        var classList = $(this).attr("class").split(/\s+/);
        $.each(classList, function(index, item){
            if (item.substring(0, 8) == "cm-code-") {
                var textToken = item.substring(8);
                gtn.ui.axml.insertIntoCode(textToken);
                gtn.ui.axml.liveEditor.focus();
            }
        });
    });
};

gtn.ui.axml.surroundCodeWithTag = function (tagName) {
    var doc = gtn.ui.axml.liveEditor.doc;
    var code = doc.getSelection();
    var cursor = doc.getCursor("from");
    var newCode = "<" + tagName + ">" + code + "</" + tagName + ">";
    doc.replaceSelection(newCode);
    // Set the cursor to just before the closing > bracket of the opening tag, so attributes can be entered manually.
    doc.setCursor({ line: cursor.line, ch: (cursor.ch + tagName.length + 1) });
};

gtn.ui.axml.insertIntoCode = function (token) {
    var doc = gtn.ui.axml.liveEditor.doc;
    var newCode = gtn.ui.axml.textDictionary[token];
    doc.replaceSelection(newCode);

    // If newCode contains new lines, apply smart-indent to the inserted code.
    var lineBreakCount = (newCode.match(/\n/g) || []).length;
    if (lineBreakCount > 0) {
        var editor = gtn.ui.axml.liveEditor;
        var currentLine = doc.getCursor().line;
        for (var line = currentLine-lineBreakCount; line <= currentLine; line++) {
            editor.indentLine(line, "smart");
        }
    }
};

gtn.ui.axml.highlightTextInLiveEditor = function (text, mouseEvent, searchHtmlVariants) {
    // (The old version of text pattern that only allows plain-text matching.)
    //var textPattern = text.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&").replace(/ /g, "\\s+");

    // Translating text into a text pattern that allows tags interspersed in between words and punctuations.
    // First search with a faster but stricter expression. If no match is found, another attempt will be made
    // to search with a slower but more thorough expression that considers &nbsp; and <br> and <br/>.
    var wordBoundaryExpression = (searchHtmlVariants ?
        "(<\\/?\\w+\\b[^>]*?>|\\s|&amp;nbsp;|&nbsp;|<br *\\/?>)*" :
        "(<\\/?\\w+\\b[^>]*?>|\\s)*");

    var textPattern = text
        // Using ` as a flag to indicate where tags can possibly be inserted around punctuations.
        // The \b (word boundary regex) didn't work well for our scenario. Using custom logic with the ` character.
        // Note the following list of punctuations is not exhaustive and may need to be expanded later.
        .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|\:\;\,\!\"\']/g, "`\\$&`")
        // Allow whitespace characters and punctuations to be surrounded by zero or more XML/HTML tags
        // and/or whitespaces of any kind, which can include the HTML variants depending on searchHtmlVariants.
        .replace(/[`\s]+/g, wordBoundaryExpression);

    //console.log(textPattern);

    var regex = new RegExp(textPattern, "gi");
    var liveEditorValue = gtn.ui.axml.liveEditor.doc.getValue();
    var result = regex.exec(liveEditorValue);
    if (result == null) {
        if (searchHtmlVariants) {
            alert("No match is found. Try selecting text at a different location.");
            // Collapse the previous selection, if any.
            var cursor = gtn.ui.axml.liveEditor.doc.getCursor();
            gtn.ui.axml.liveEditor.doc.setCursor(cursor);

        } else {
            // Search again including the HTML variants, which is more thorough but slower.
            gtn.ui.axml.highlightTextInLiveEditor(text, mouseEvent, true);
        }

    } else {
        // Record the first match.
        var startIndex = result.index;
        var endIndex = regex.lastIndex;
        // Test if there is a second match.
        if (regex.exec(liveEditorValue) != null) {
            alert("Multiple matches are returned from your selection. Try selecting a longer span of text.");
            // Collapse the previous selection, if any.
            var cursor = gtn.ui.axml.liveEditor.doc.getCursor();
            gtn.ui.axml.liveEditor.doc.setCursor(cursor);

        } else {
            // Select the match when it is the one and only match returned.
            var startPos = gtn.ui.axml.liveEditor.doc.posFromIndex(startIndex);
            var endPos = gtn.ui.axml.liveEditor.doc.posFromIndex(endIndex);
            gtn.ui.axml.liveEditor.doc.setSelection(startPos, endPos);
            /* Scroll the match to the same vertical position as the original selected text. */
            // textTop: the distance between the original text and the top edge of the HTML document.
            var textTop = mouseEvent.pageY;
            // textTopOffset: the distance between the original text and the top edge of the browser viewport.
            var textTopOffset = textTop - $(window).scrollTop();
            // matchTop: the distance between the match and the top edge of the XML document.
            var matchTop = gtn.ui.axml.liveEditor.cursorCoords(startPos, "local").top;
            // liveEditorScrollTop: the optimal vertical scroll position of the live editor (with 77px adjustment).
            var liveEditorScrollTop = matchTop - textTopOffset + 77;
            // Scroll to the optimal vertical position.
            gtn.ui.axml.liveEditor.scrollTo(null, liveEditorScrollTop);
        }
    }
};

gtn.ui.axml.syncLiveEditorCleanStateWithUI = function (cm, changeObj, syncRequestSource) {
    $(".editor-panel").toggleClass("is-dirty",
        !gtn.ui.axml.liveEditor.doc.isClean(gtn.ui.axml.liveEditorLastGeneration));

    //console.log(syncRequestSource + " is clean: " +
    //    gtn.ui.axml.liveEditor.doc.isClean(gtn.ui.axml.liveEditorLastGeneration));
};

gtn.ui.axml.saveXmlIfChanged = function () {
    // Only save the file when it has been edited in Live Editor, and when there is no other save in progress.
    if (!gtn.ui.axml.liveEditor.doc.isClean(gtn.ui.axml.liveEditorLastGeneration)
        && !gtn.ui.axml.liveEditorIsSaving) {

        // Flag the Live Editor as being saved (so saves do not overlap).
        // The save flag also blocks the continuous background fetch from trying to update the live editor.
        gtn.ui.axml.liveEditorIsSaving = true;
        gtn.ui.axml.liveEditorLastGeneration = gtn.ui.axml.liveEditor.doc.changeGeneration();
        gtn.ui.axml.liveEditorLastGenerationXmlText = gtn.ui.axml.liveEditor.doc.getValue();

        // Save the changed XML code to the server.
        $.ajax({
            url: "/savedoc",
            type: "POST",
            data: {
                _csrf: gtn.ui._csrf,
                url: "/axml" + gtn.ui.axml.sourceUrl,
                xml: gtn.ui.axml.liveEditorLastGenerationXmlText
            },
            dataType: "json", // the type of data that will be returned from server.
            beforeSend: function (jqXHR, settings) {
                // Do nothing.
            },
            success: function (data, textStatus, jqXHR) {
                if (data.isSuccess) {
                    gtn.ui.axml.syncLiveEditorCleanStateWithUI(null, null, "after-save");
                } else {
                    alert(data.errorSummary);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                alert("Status " + jqXHR.status + ": " + (jqXHR.responseText || textStatus || errorThrown));
            },
            complete: function (jqXHR, textStatus) {
                // Reset the saving flag.
                gtn.ui.axml.liveEditorIsSaving = false;
            }
        });
    }
};

gtn.ui.axml.getSelectionText = function () {
    var text = "";
    if (window.getSelection) {
        text = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
        text = document.selection.createRange().text;
    }
    return text;
};


// An article should have a minimum number of 2 sections in order to have a sidebar.
// If there is only one section (or no section at all), a sidebar is not needed.
gtn.ui.axml.minSectionsToCreateSideBar = 2;


gtn.ui.axml.includeFiles = [];

/*
    DEPRECATED - NOW HANDLED ON SERVER
 */
gtn.ui.axml.processInclude = function (include) {
    var $include = $(include);
    var src = $include.attr("src");

    // See if the desired XML file is in the includeFiles cache.
    var includeFileCache = $.grep(gtn.ui.axml.includeFiles, function (element, index) {
        return (element.src == src);
    });

    // Retrieve the XML text either from cache or from a new AJAX request.
    var xmlText = null;
    if (includeFileCache.length > 0) {
        xmlText = includeFileCache[0].xmlText;

    } else {
        //alert("Making an ajax request...");
        $.ajax({
            type: "GET",
            url: src,
            cache: gtn.ajaxCache,
            async: false,
            dataType: "text",    // It is easier to do global text replace with a return type "text" rather than "xml".
            success: function(text) {
                xmlText = text;
                gtn.ui.axml.includeFiles.push({ src: src, xmlText: xmlText });
            }
        });
    }

    // Replace the text or nodes globally in the XML.
    $include.find("> replace:not(:has( > text[selector]))").each(function () {
        var $replace = $(this);
        var searchText = $replace.attr("text") || $replace.find("text").contentsToXml();
        var replacementText = $replace.attr("with") || $replace.find("with").contentsToXml();
        xmlText = xmlText.replace(new RegExp(searchText, 'g'), replacementText);
    });

    // Extract the portion that is indicated by the reference and/or selector.
    var $includeFile = $($.parseXML(xmlText));
    var ref = $include.attr("ref");
    var selector = $include.attr("selector");
    var $includeContent = (ref || selector) ?
        $includeFile.find((ref ? "#" + ref + " " : "") + (selector ? selector : "")) :
        $includeFile.find(":root");

    // Replace contents in certain nodes in the XML.
    // Note $includeContent.find() only searches the descendant nodes, not the top-level nodes in $includeContent.
    $include.find("> replace:has( > text[selector])").each(function () {
        var $replace = $(this);
        var $text = $replace.children("text");
        var $with = $replace.children("with");
        switch ($text.attr("type")) {
            case "inner-xml":
                $includeContent.find($text.attr("selector"))
                    .empty()
                    .append($with.contents());
                break;

            case "outer-xml":
                $includeContent.find($text.attr("selector"))
                    .replaceWith($with.contents());
                break;

            default:
                alert("The type value of '" + $text.attr("type") + "' is not valid.");
                break;
        }
    });

    // Remove content from the XML.
    $include.find("> remove").each(function () {
        var $remove = $(this);
        $includeContent.find($remove.attr("selector")).remove();
    });

    // Insert content into the XML, before or after the selected node(s).
    $include.find("> insert").each(function () {
        var $insert = $(this);
        switch ($insert.attr("position")) {
            case "before":
                // Insert before the selected node(s).
                $includeContent.find($insert.attr("selector")).before($insert.contents());
                break;

            case "inside":
                // Insert inside the selected node(s) as children.
                $includeContent.find($insert.attr("selector")).append($insert.contents());
                break;

            case "after":
                // Insert after the selected node(s).
                $includeContent.find($insert.attr("selector")).after($insert.contents());
                break;

            default:
                alert("The position value of '" + $insert.attr("position") + "' is not valid.");
                break;
        }
    });

    // When using jQuery on XML document, many of the node operations (e.g. append() or replaceWith())
    // can only accept an object, not a string. This behavior is different from using jQuery on HTML.
    // See: http://stackoverflow.com/questions/4262960/is-it-possible-to-add-delete-xml-nodes-with-jquery-ajax
    $include.replaceWith($includeContent);
};

// Reserved for use in contentsToXml().
gtn.ui.axml.xmlSerializer = null;

// The following function has only been tested for the <replace> tag. Not recommended for other uses.
$.fn.contentsToXml = function () {
    var xml = "";

    // The jQuery html() errors out on XML nodes in Safari and IE,
    // but works in Chrome and Firefox to produce the inner XML string.
    try {
        xml = this.html();
    }
    catch (e) {
        // For Safari and IE, use the XMLSerializer instead.
        if (gtn.ui.axml.xmlSerializer == null) { gtn.ui.axml.xmlSerializer = new XMLSerializer(); }
        var outerXml = gtn.ui.axml.xmlSerializer.serializeToString(this[0]);
        var startIndex = outerXml.indexOf(">") + 1;
        var endIndex = outerXml.lastIndexOf("<");
        xml = outerXml.substring(startIndex, endIndex);
    }

    return xml;
};

gtn.ui.bootstrapBlog = function( blog ){
    var _this = $(blog);
    var blog_def = $(_this).find('blog-definition') ;
    var article = $(_this).find('> document > article');
    var tags = blog_def.attr('tags');

    var wrapper = $('<div/>').css('margin-bottom', '10px');
    if( tags ){
        var $li , $sp;
        var tagsArr = tags.split(',');
        var $ul = $('<ul/>').addClass('k-reset k-multiselect');
        tagsArr.forEach(function(t){
            $li = $('<li/>').addClass('k-button').css('cursor' , 'default').css('margin-right' , "2px");
            $sp = $('<span/>').attr('unselectable' , 'on').text(t);
            $li.append($sp);
            $ul.append($li);
        });
        wrapper.append($ul);
    }
    var author = blog_def.attr('author') || 'Infor Nexus Evangelism Team';
    wrapper.append('<i style="margin-left:5%;">Submitted On : ' + blog_def.attr('date') + ' by ' + author + '</i><br/>');
    wrapper.insertAfter( article.find('> .article-title'));
    var footer = '<br/><b>Posted By : ' + author + '</b>';
    var askAQuestion = '<div style="margin-bottom: 20px"><i>Have any questions? Go <a href="/user/ask-an-evangelist">here</a> ' +
        'to directly ask the Infor Nexus Evangelist team</i></div>';
    article.append(footer).append(askAQuestion);
    return _this.prop('outerHTML');
};

$.fn.attributesToString = function () {
    var attrString = "";

    // Note the prop("attributes") command will return pre-defined and dynamically added classes
    // in Safari, Chrome and Firefox, but will only return pre-defined classes in IE.
    // That's why the retrieval of the class name(s) is currently performed outside of this function.
    $.each(this.prop("attributes"), function () {
        attrString += this.name + "=\"" + this.value + "\" ";
    });

    return attrString;
};

gtn.ui.axml.normalizeCode = function (code) {
    // Escape the angle brackets first.
    code = code.replace(/</g, "&lt;").replace(/>/g, "&gt;");

    // Start analyze code lines to achieve optimal indentation.
    var lines = code.split("\n");

    // Find the first significant line.
    var normalizedStart = -1;
    for (var i = 0; i < lines.length; i++) {
        if (normalizedStart == -1 && $.trim(lines[i]).length > 0) {
            normalizedStart = i;
            break;
        }
    }

    // Find the last significant line.
    var normalizedEnd = -1;
    for (var i = lines.length - 1; i >= 0 ; i--) {
        if (normalizedEnd == -1 && $.trim(lines[i]).length > 0) {
            normalizedEnd = i;
            break;
        }
    }

    // Compute the number of leading whitespaces (offset)
    // that should be removed from the entire code block.
    var referenceLine = lines[normalizedStart];
    var normalizedLine = referenceLine.replace(/^\s+/,"");  // the same as LTRIM()
    lines[normalizedStart] = normalizedLine;
    var offset = referenceLine.length - normalizedLine.length;

    // Remove the leading offset whitespaces.
    for (var i = normalizedStart + 1; i <= normalizedEnd; i++) {
        var line = lines[i];
        if ($.trim(line.substr(0, offset)) == "") {
            // The leading offset whitespaces are safe to remove.
            lines[i] = line.substr(offset);
        } else {
            // There is an irregularity in the code formatting.
            // Do not remove anything.
        }
    }

    // Return only the significant lines, with the leading offset whitespaces removed.
    return lines.slice(normalizedStart, normalizedEnd + 1).join("\n");
};

gtn.ui.axml.syncSectionsWithSidebar = function () {
    var triggerThreshold = 90;
    var thresholds = [];
    var $sectionTitles = $(".article-content .section-title");
    var $anchors = getPageAnchorLinks();

    function getPageAnchorLinks() {
        return $(".article-sidebar > .anchor");
    }

    // Create an array of threshold points (one for the article title and each section title).
    // Threshold point for article title is 0.
    thresholds.push(0);
    // Threshold point for sectional title is (offset().top - triggerThreshold) in pixels.
    $sectionTitles.each(function () {
        thresholds.push($(this).offset().top - triggerThreshold);
    });

    var setAnchorAsActive = function (activeIndex) {
        var $activeAnchor = getPageAnchorLinks().eq(activeIndex);
        if (! $activeAnchor.hasClass("active") ) {
            getPageAnchorLinks().filter(".active").removeClass("active");
            $activeAnchor.addClass("active");
            $slider.css({ top: $activeAnchor.position().top + 8 });
        }
    };

    $anchors.click(function () {
        var anchorIndex = $anchors.index(this);
        setAnchorAsActive(anchorIndex);
        gtn.ui.axml.sidebarAnchorClicked = true;
        if (anchorIndex == 0) {
            gtn.setHash("section", "");
        } else {
            var lowerAnchorText = $($anchors[anchorIndex]).text().toLowerCase();
            gtn.setHash("section", gtn.ui.hyphenEncode(lowerAnchorText));
        }
        // Turn on the sidebarAnchorClicked flag, in order to suppress the window scroll event handler logic.
        gtn.ui.axml.sidebarAnchorClicked = true;
        // Now scroll the document window. Because of the sidebarAnchorClicked flag,
        // the window scroll event handler will not do anything.
        try {
            //$(window).off("scroll", handlePageScroll);
            $(window).scrollTop(thresholds[anchorIndex]);
            //$(window).on("on", handlePageScroll);
        } catch(err) {
            console.error(err);
        }
        // Set the sidebarAnchorClicked to be turned off after a short delay, so the window scroll can finish.
        setTimeout(function () { gtn.ui.axml.sidebarAnchorClicked = false;}, 100);
    });

    var $slider = $(".article-sidebar > .slider");

    var handlePageScroll = function () {
        // If the scroll is triggered by an anchor click, don't do anything at all.
        if (gtn.ui.axml.sidebarAnchorClicked) { return; }

        /* The following code will only be hit when user actually scrolls the page, not clicking the anchor. */
        // Find the section title whose threshold point is immediately above (<=) the scroll position.
        // That is the section currently being viewed.
        var scrollTop = $(this).scrollTop();
        if (scrollTop <= 0) {
            setAnchorAsActive(0);       // highlight the anchor for the article title.

        } else if ((scrollTop + $(window).height()) >= ($(document).height() - 10)) {
            // scrollTop is the same as the number of pixels that are hidden from view above the scrollable area.
            // If the scroll bar is at the very top, or if the element is not scrollable, this number will be 0.
            // If (scrollTop + windowHeight) == documentHeight, user has scrolled to the bottom of the page.
            // In this case, just highlight the last sidebar anchor. This is necessary because if the last section
            // is very short, it can never be scrolled far down enough to make the section title appear close to
            // the top of the window, which means that particular sidebar anchor would never get to be highlighted.
            // Therefore, we need some additional logic to make that anchor highlighted when user has scrolled to
            // the bottom of the page. (Here it is defined as within 10 px of the bottom of the document.
            // The 10px is needed because some browsers or mouses have a "bouncing" effect when scrolled to the bottom,
            // and that would cause the scrollTop value to fluctuate a little bit. Need to accommodate that.)
            setAnchorAsActive($anchors.length - 1);

        } else {
            var titleIndex;
            for (titleIndex = thresholds.length - 1; titleIndex >= 0; titleIndex--) {
                if (thresholds[titleIndex] <= scrollTop) { break; }
            }

            // Find the anchor that is mapped to the currently viewed section.
            // Apply "active" class to that anchor, and move the slider to that anchor.
            setAnchorAsActive(titleIndex);
        }
    };

    // In Live Edit mode, because the window object stays the same and syncSectionsWithSidebar() is called
    // every time the page content is changed, we need to be careful about the window object's event handling.
    // The page seemed to work fine without the "off" function, but it's possible that duplicate handlers were being run.
    // It is hard to verify it, because the scroll events can fire many times even on a small amount of scroll.
    // Therefore, it is safer to keep the "off" function to make sure only one handlePageScroll instance is running.
    $(window).off("scroll", handlePageScroll);
    $(window).on( "scroll", handlePageScroll);

    // Trigger the window scroll event once, so the correct anchor is highlighted on page load (including page refresh).
    $(window).scroll();
};

$(document).on("article:heightChange", function () {
    // Sync the section positions with the sidebar anchors.
    // This has to be executed after a short delay on page load ( from react/doc.js ) , to wait until the page is completely rendered.
    if ($(".article-sidebar > .anchor.for-section").length >= gtn.ui.axml.minSectionsToCreateSideBar) {
        gtn.ui.axml.syncSectionsWithSidebar();
    }
});

gtn.ui.openOriginalPicture = function (img) {

    // New custom image viewer because Soho wants jQuery 3.1.0, but the Kendo image viewer doesn't like it
    var window = $('.img-window');
    window.css('max-width', img.naturalWidth + 32 + 32 + 'px');
    window.css('max-height', img.naturalHeight + 52 + 32 + 'px');

    $('.img-window img').attr('src', $(img).attr('src'));
    $('body').toggleClass('img-open');
};

 //TODO FIX awful code
gtn.ui.axml.adjustJsonCodeHeight = function () {
    //Iterating over same container - no need to get its height each time in function below
    var containerHeight;

    $("pre.language-json").each(function () {
        var $container = $(this);
        var $code = $container.find("> code");
        containerHeight = containerHeight || $container.height();
        var codeHeight = $code.height();
        if (codeHeight > containerHeight) {
            $container.after("<div class='json-height-toggle'>Expand code viewer to full height</div>");
            $container.next().click( function(){
                // Toggle the container's CSS class.
                $container.toggleClass("no-height-limit");
                // Toggle the button's text between "Expand" and "Shrink".
                if ($container.hasClass("no-height-limit")) {
                    $(this).text("Shrink code viewer");
                } else {
                    $(this).text("Expand code viewer to full height");
                }
                // Scroll the container into view, so it doesn't disappear from view when shrunk.
                // Leave a 80px distance between the container and the top edge of the view port.
                $(document).scrollTop($container.offset().top - 80);
                // Fire the "article:heightChange" event to keep elements in sync.
                $(document).trigger("article:heightChange");
            } );
        }
    });
};


Prism.languages.dust = {
    // Match the beginning import instruction.
    'import': {
        pattern: /\{\>\w+\/\}/g,
        alias: "important",  // borrow the existing visual styles.
        inside: {
            'punctuation': /[\{\}\<\>\/]/g
        }
    },
    // Match the subject, body and signature sections.
    'section': {
        pattern: /\{[\<\/](subject|body|signature)\}/gi,
        alias: "function",
        inside: {
            'punctuation': /[\{\}\<\>\/]/g
        }
    },
    // Match the dynamic-value keys.
    'key': {
        pattern: /\{\w+\}/g,
        alias: "keyword",
        inside: {
            'punctuation': /[\{\}\<\>\/]/g
        }
    },
    // Match the line breaks {~n}.
    'punctuation': /\{~n\}/g
};

Prism.languages.json = {
    'property': {
        pattern: /("|')([\$\.\w]+?)\1\s*?:/g,
        inside: {
            'punctuation': /["':]/g
        }
    },
    'string': /("|')(\\?.)*?\1/g,
    'boolean': /\b(true|false)\b/g,
    'number': /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee]-?\d+)?|NaN|-?Infinity)\b/g,
    'function':{
        pattern: /[a-z0-9_]+\(/gi,
        inside: {
            punctuation:/\(/
        }
    },
    'array': /[\[\]]/g,
    'object': /[\{\}]/g,
    'punctuation': /[,]/g
};


gtn.ui.axml.toggleObjectSchemaNode = function (e) {
    // Cancel the default "select" action that highlights the text.
    e.preventDefault();
    var schemaDataItem = this.dataItem(e.node);
    if (schemaDataItem.items != null && schemaDataItem.items.length != 0) {
        // Toggle the node between expanded and collapsed states.
        this.toggle($(e.node));
        $(document).trigger("article:heightChange");
    }
};

gtn.ui.axml.renderFilesWidgets = function () {
    $(".files").each(function () {
        var $filesWidget = $(this);
        // Retrieve the schema.
        var filesJson = JSON.parse($filesWidget.children(".files-json").text());
        // Render the tree view.
        var filesTree = $filesWidget.children(".files-tree").kendoTreeView({
            template:
                "<span class='k-sprite #= (item.folder ? \"folder\" : \"file\") #'></span>" +
                "<span class='file-item-name'>#= (item.folder || item.file) #</span>",
            dataSource: filesJson,
            animation: false,
            // Disable node selection.
            select: function (e) { e.preventDefault(); },
            // Disable node expansion except when the tree is still rendering.
            expand: function (e) { if (this.renderingComplete) { e.preventDefault(); } },
            // Disable node collapse.
            collapse: function (e) { e.preventDefault(); }
        }).data("kendoTreeView");
        // Expand the tree completely.
        filesTree.expand("li");
        // Add a flag to indicate the rendering is complete. Now the tree nodes cannot be toggled.
        filesTree.renderingComplete = true;
    });
};

gtn.ui.axml.selectVersionByHash = function (versionInHash) {
    var matchedTab = $(".article-panel > .version-tab-list > .version-tab[data-version='" + versionInHash + "']");
    if (matchedTab.length > 0) {
        matchedTab.click();
    } else {
        alert("The version number specified in the web address is not valid. " +
            "The latest version tab will be displayed instead.");
    }
};

gtn.ui.axml.selectSectionByHash = function (sectionInHash) {
    var isMatchFound = false;
    $(".article-sidebar > .anchor").each(function () {
        var lowerAnchorText = $(this).text().toLowerCase();
        if (gtn.ui.hyphenEncode(lowerAnchorText) == sectionInHash) {
            isMatchFound = true;
            $(this).click();
            var clickEven = new Event('')
        }
    });

    if (isMatchFound == false) {
        alert("The article section specified in the web address is not valid. " +
            "The article will be displayed from the beginning.");
    }
};

gtn.page.displayErrors = function(response){
    var errordiv = $('.m-page-summary-errors > ul');
    errordiv.empty();
    if(response && response.errors ){
        var errors = response.errors;
        for(var i = 0 ; i < errors.length ; i++){
            errordiv.append('<li>' + errors[i].message + '</li>');
        }
    }else{
        errordiv.append("<li>Server error; please contact Infor Nexus</li>");
    }
    errordiv.parent().show();
};

/*
    Used on documents page to jump to a specific section
 */
gtn.page.jumpToSection = function(a){
    var section = a.getAttribute('data-division');
    //trigger click on appropriate section
    $('.article-sidebar .for-section').each(function(){
       if( $(this).text() == section ){
           $(this).click();
           return false;
       }
    });
};


Date.prototype.getHumanReadableDate = function(){
    return this.getMonthNameShort() + " " + this.getDate() + " , " +this.getFullYear();
}

Date.prototype.getMonthName = function(lang) {
    lang = lang && (lang in Date.locale) ? lang : 'en';
    return Date.locale[lang].month_names[this.getMonth()];
};

Date.prototype.getMonthNameShort = function(lang) {
    lang = lang && (lang in Date.locale) ? lang : 'en';
    return Date.locale[lang].month_names_short[this.getMonth()];
};

Date.locale = {
    en: {
        month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
};

$(document).on('bind-events-to-axml-page' , () => {
    $('schema .object-schema .k-icon, schema .object-schema .k-mid > .k-in').click( toggleSchemaNode );
    $('.json-height-toggle').click( toggleJsonCodeHeight)
});

function toggleSchemaNode(e){
    let $icon = $(this).hasClass('k-icon') ? $(this) : $(this).parent().find('> .k-icon');
    let $item = $icon.parent().parent('li');

    //Toggle open
    $icon.hasClass('k-plus') ? $item.find('> ul').css('display' , 'block') : $item.find('> ul').hide();
    $icon.toggleClass('k-plus k-minus');
}

function toggleJsonCodeHeight(e){
    var $container = $(this).prev();
    // Toggle the container's CSS class.
    $container.toggleClass("no-height-limit");
    // Toggle the button's text between "Expand" and "Shrink".
    if ($container.hasClass("no-height-limit")) {
        $(this).text("Shrink code viewer");
    } else {
        $(this).text("Expand code viewer to full height");
    }
    // Scroll the container into view, so it doesn't disappear from view when shrunk.
    // Leave a 80px distance between the container and the top edge of the view port.
    $(document).scrollTop($container.offset().top - 80);
    // Fire the "article:heightChange" event to keep elements in sync.
    $(document).trigger("article:heightChange");
}




// WEBPACK FOOTER //
// ./public/javascripts/GTNexus.Axml.js